import { Dialog, DialogProps } from "@mui/material";

export function RenderDialog(props: DialogProps & { handleClearDialog: () => void }) {
  const { children, handleClearDialog, ...rest } = props;
  return (
    <Dialog
      id="campaigns-dialog"
      data-test="campaigns-dialog"
      onClose={handleClearDialog}
      maxWidth="sm"
      fullWidth
      {...rest}
    >
      {children}
    </Dialog>
  );
}
